import { QuizModelType } from "../types/quiz.types";

export const QuizModel: QuizModelType[] = [
    {
        quizName: 'Devil Fruits',
        quizId: '71850543-9797-4093-bc63-1e6b26df5d26',
        image: 'https://res.cloudinary.com/randomwave45/image/upload/v1652634504/c81786f0-4dfc-4131-8d60-9df175368423_zf6mk3.jpg',
        quizCategory: 'easy',
        points: 10,
        questions: [
            {
                question: 'Which is the strongest devil fruit ?',
        point: 10,
        options: [
          {
            value: 'Paramecia',
            isRight: false,
          },
          {
            value: 'Logia',
            isRight: true,
          },
          {
            value: 'Zoan',
            isRight: false,
          },
          {
            value: 'Canon',
            isRight: false,
          },
        ],
            },
            {
                question: 'What is the total count of devil fruits ?',
        point: 10,
        options: [
          {
            value: '191',
            isRight: true,
          },
          {
            value: '180',
            isRight: false,
          },
          {
            value: '78',
            isRight: false,
          },
          {
            value: '145',
            isRight: false,
          },
        ],
            },
            {
                question: 'Which of the following devil fruit powers returned into circulation ?',
        point: 10,
        options: [
          {
            value: 'Gas Gas Fruit',
            isRight: false,
          },
          {
            value: 'Wax Wax Fruit',
            isRight: false,
          },
          {
            value: 'Flame Flame Fruit',
            isRight: true,
          },
          {
            value: 'Gum Gum Fruit',
            isRight: false,
          },
        ],
            },
            {
                question: 'What is the consequence of devil fruit consumption ?',
        point: 10,
        options: [
          {
            value: 'Increase in appetite',
            isRight: false,
          },
          {
            value: 'Weakness to water',
            isRight: true,
          },
          {
            value: 'Headache',
            isRight: false,
          },
          {
            value: 'Fuzziness',
            isRight: false,
          },
        ],
            },
            {
                question: 'Can a normal person eat more than 1 devil fruit ?',
        point: 10,
        options: [
          {
            value: 'Yes',
            isRight: false,
          },
          {
            value: 'No',
            isRight: true,
          },
        ],
            },
        ]
    },
    {
        quizName: 'Kages',
        quizId: '85c493d3-04c1-43c1-827f-e6b9286b14e3',
        image: 'https://res.cloudinary.com/randomwave45/image/upload/v1652634423/78abefed-7c35-4b4f-a78b-2592bc5629c1_lavymo.jpg',
        quizCategory: 'easy',
        points: 10,
        questions: [
            {
                question: 'Which kage is referred to as "God of Shinobi" ?',
        point: 10,
        options: [
          {
            value: 'Tobirama',
            isRight: false,
          },
          {
            value: 'Hashirama',
            isRight: true,
          },
          {
            value: 'Gara',
            isRight: false,
          },
          {
            value: 'Naruto',
            isRight: false,
          },
        ],
            },
            {
                question: 'Who of the following is the Kekki Tota user ?',
        point: 10,
        options: [
          {
            value: 'Mu',
            isRight: true,
          },
          {
            value: 'Madara Uchiha',
            isRight: false,
          },
          {
            value: 'Yagura',
            isRight: false,
          },
          {
            value: 'Gengetsu',
            isRight: false,
          },
        ],
            },
            {
                question: 'Which Hokage mastered medical ninjutsu ?',
        point: 10,
        options: [
          {
            value: 'Hiruzen',
            isRight: false,
          },
          {
            value: 'Kakashi',
            isRight: false,
          },
          {
            value: 'Tsunade',
            isRight: true,
          },
          {
            value: 'Minato',
            isRight: false,
          },
        ],
            },
            {
                question: 'Who pioneered teleportation ninjutsu?',
        point: 10,
        options: [
          {
            value: 'Onoki',
            isRight: false,
          },
          {
            value: 'Tobirama',
            isRight: true,
          },
          {
            value: 'Minato',
            isRight: false,
          },
          {
            value: 'Hashirama',
            isRight: false,
          },
        ],
            },
            {
                question: 'Who of the following is not a jinchuriki ?',
        point: 10,
        options: [
          {
            value: 'Naruto',
            isRight: false,
          },
          {
            value: 'Gara',
            isRight: false,
          },
          {
            value: 'Darui',
            isRight: true,
          },
          {
            value: 'Yagura',
            isRight: false,
          },
        ],
            },
        ]
    },
    {
        quizName: 'Forbidden Jutsu',
        quizId: 'dab835f0-6241-4985-9cc0-de38d491ee29',
        image: 'https://res.cloudinary.com/randomwave45/image/upload/v1652600420/wp7674077_p8sijj.webp',
        quizCategory: 'medium',
        points: 20,
        questions: [
            {
                question: 'Who invented Re-animation jutsu ?',
        point: 20,
        options: [
          {
            value: 'Minato',
            isRight: false,
          },
          {
            value: 'Tobirama',
            isRight: true,
          },
          {
            value: 'Orochimaru',
            isRight: false,
          },
          {
            value: 'Madara',
            isRight: false,
          },
        ],
            },
            {
                question: 'Which forbidden jutsu does Naruto uses frequently ?',
        point: 20,
        options: [
          {
            value: 'Re-animation',
            isRight: false,
          },
          {
            value: 'Rinne Rebirth',
            isRight: false,
          },
          {
            value: 'Multi Shadow Clone',
            isRight: true,
          },
          {
            value: 'Reaper Death Seal',
            isRight: false,
          },
        ],
            },
            {
                question: "What is the Uchiha clans's forbidden jutsu ?",
        point: 20,
        options: [
          {
            value: 'Reaper Death Seal',
            isRight: false,
          },
          {
            value: 'Fire Ball',
            isRight: false,
          },
          {
            value: 'Izanagi-Izanami',
            isRight: true,
          },
          {
            value: 'Susano',
            isRight: false,
          },
        ],
            },
            {
                question: 'Which forbidden jutsu did Orochimaru used on child Sasuke ?',
        point: 20,
        options: [
          {
            value: 'Genjutsu',
            isRight: false,
          },
          {
            value: 'Cursed Seal of Heaven and Earth',
            isRight: true,
          },
          {
            value: 'Twin Snake Sacrifice',
            isRight: false,
          },
          {
            value: 'Re-animation',
            isRight: false,
          },
        ],
            },
            {
                question: 'Which visual prowess alowed to use Rinne Rebirth ?',
        point: 20,
        options: [
          {
            value: 'Sharingan',
            isRight: false,
          },
          {
            value: 'Byakugan',
            isRight: false,
          },
          {
            value: 'Rinnegan',
            isRight: true,
          },
          {
            value: 'Jougan',
            isRight: false,
          },
        ],
            },
        ]
    },
    {
        quizName: 'Nicknames',
        quizId: 'dab835f0-6241-4985-9cc0-de38d491bb50',
        image: 'https://res.cloudinary.com/randomwave45/image/upload/v1652634672/df35b83d-4fd6-49b0-bfea-b4bd3c7f910c_ijstzh.jpg',
        quizCategory: 'medium',
        points: 20,
        questions: [
            {
                question: 'What was Minato called ?',
        point: 20,
        options: [
          {
            value: 'Powerhouse',
            isRight: false,
          },
          {
            value: 'Yellow Flash',
            isRight: true,
          },
          {
            value: 'Hero of the Leaf',
            isRight: false,
          },
          {
            value: 'Clutch Master',
            isRight: false,
          },
        ],
            },
            {
                question: 'Who was referred to as Copy Ninja ?',
        point: 20,
        options: [
          {
            value: 'Sauske',
            isRight: false,
          },
          {
            value: 'Naruto',
            isRight: false,
          },
          {
            value: 'Kakashi',
            isRight: true,
          },
          {
            value: 'Itachi',
            isRight: false,
          },
        ],
            },
            {
                question: "What was Sasuke entitled with ?",
        point: 20,
        options: [
          {
            value: 'Last survivor',
            isRight: false,
          },
          {
            value: 'Ghost of Uchiha',
            isRight: false,
          },
          {
            value: 'Last Uchiha',
            isRight: true,
          },
          {
            value: 'Beast',
            isRight: false,
          },
        ],
            },
            {
                question: 'Who was Green Beast of the Leaf ?',
        point: 20,
        options: [
          {
            value: 'Hashiram',
            isRight: false,
          },
          {
            value: 'Might Guy',
            isRight: true,
          },
          {
            value: 'Hiruzen',
            isRight: false,
          },
          {
            value: 'Asuma',
            isRight: false,
          },
        ],
            },
            {
                question: 'Who was Sakumo Hatake ?',
        point: 20,
        options: [
          {
            value: 'Beast',
            isRight: false,
          },
          {
            value: 'Last survivor',
            isRight: false,
          },
          {
            value: 'White fang',
            isRight: true,
          },
          {
            value: 'Toad Sage',
            isRight: false,
          },
        ],
            },
        ]
    },
    {
        quizName: 'Visual Prowess',
        quizId: '2b088b84-a6b3-4cbe-8b59-dc8c0a9f037f',
        image: 'https://res.cloudinary.com/randomwave45/image/upload/v1652634584/83960158-ef07-4df5-b4bc-3f0a64d459b6_ut5ggt.jpg',
        quizCategory: 'hard',
        points: 30,
        questions: [
            {
                question: 'Which is the strongest among the following ?',
        point: 30,
        options: [
          {
            value: 'Sharingan',
            isRight: false,
          },
          {
            value: 'Byakugan',
            isRight: false,
          },
          {
            value: 'Jougan',
            isRight: false,
          },
          {
            value: 'Rinnegan',
            isRight: true,
          },
        ],
            },
            {
                question: 'Development stages of sharingan',
        point: 30,
        options: [
          {
            value: 'Byakugan-Sharigan-Magekyo',
            isRight: false,
          },
          {
            value: 'Rinnegan-Sharigan-Magekyo',
            isRight: false,
          },
          {
            value: 'Sharingan-Mangekyo-Rinnegan',
            isRight: true,
          },
          {
            value: 'Rinnegan-Mangekyo-Sharingan',
            isRight: false,
          },
        ],
            },
            {
                question: "Who awakened the first Susano ?",
        point: 30,
        options: [
          {
            value: 'Madara',
            isRight: false,
          },
          {
            value: 'Itachi',
            isRight: false,
          },
          {
            value: 'Indra',
            isRight: true,
          },
          {
            value: 'Shisui',
            isRight: false,
          },
        ],
            },
            {
                question: 'Which od the following non-dojutsu is stronger than Sharingan ?',
        point: 30,
        options: [
          {
            value: 'Dead Bone Pulse',
            isRight: false,
          },
          {
            value: 'Sage Mode Eyes',
            isRight: true,
          },
          {
            value: 'Lava release',
            isRight: false,
          },
          {
            value: 'Mud release',
            isRight: false,
          },
        ],
            },
            {
                question: 'What is the name of the jutsu that keeps on burning until the target is turned to ashes ?',
        point: 30,
        options: [
          {
            value: 'Lava release',
            isRight: false,
          },
          {
            value: 'Fire ball',
            isRight: false,
          },
          {
            value: 'Amaterasu',
            isRight: true,
          },
          {
            value: 'None of the above',
            isRight: false,
          },
        ],
            },
        ]
    },
]